import parse, { domToReact } from "html-react-parser";
import classNames from "classnames";
import Image from "./image";
import { useTranslation } from "./translate";

const CmsContent = ({ data, className }) => {
  const parseOpt = {
    replace: (elem) => {
      if (elem.type === "tag" && elem.name === "p" && elem.children?.[0]?.name === "img") {
        const className = elem.children?.[0]?.attribs?.class;
        const float = className?.includes("float--") && className.split("--")?.[1];
        if (["left", "right"].includes(float)) {
          return <p className="floating">{domToReact(elem.children, parseOpt)}</p>;
        }
      }
      if (elem.type === "tag" && elem.name === "img") {
        const className = elem.attribs?.class;
        const float = className?.includes("float--") && className.split("--")?.[1];
        return elem.attribs?.["data-useoriginalimage"] === "true" ? (
          <img
            src={elem.attribs?.["data-uri"]}
            alt={elem.attribs?.alt || ""}
            className={className}
          />
        ) : (
          <Image
            cropUrlTemplate={elem.attribs?.["data-uritemplate"]}
            crops={[
              {
                crop: "landscape_ratio16x9",
                sizes: [
                  {
                    breakpoint: 992,
                    maxWidth: "100vw",
                  },
                  {
                    breakpoint: 1230,
                    maxWidth: ["left", "right"].includes(float) ? "380px" : "70vw",
                  },
                  {
                    maxWidth: ["left", "right"].includes(float) ? "520px" : "720px",
                  },
                ],
              },
            ]}
            className={className}
            alt={elem.attribs?.alt || ""}
          />
        );
      }
    },
  };

  const result = useTranslation(data?.description);

  return result ? (
    <div className={classNames("content text loading-highlighted", className)}>
      {parse(result, parseOpt)}
    </div>
  ) : null;
};

export default CmsContent;
